export const MuiStepConnectorTheme = () => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                display: "none",
            },
        },
    };
};
